import angular from 'angular';

export default angular
  .module('app.directives.disable-element', [])
  .directive('disableElement', $timeout => ({
    restrict: 'A',
    scope: {
      disable: '=disableElement',
      disableText: '@?',
    },
    link(scope, element, attrs) {
      let text = {};

      // This is a hack to fix the button value going to
      //     '{{modalOptions.actionButtonText}}'
      $timeout(
        () =>
          (text = {
            enable: element.html() || element.val(),
            disable: scope.disableText || 'sending...',
          })
      );

      /**
       * Change the state of the element
       * @param  {Boolean} disable Whether to disable the element or not
       */
      let change = function(disable) {
        if (disable == null) {
          disable = false;
        }
        let action = disable ? 'disable' : 'enable';

        // If text[action] is undefined html is going to return a string not a
        // chainable. So do this over multiple lines.
        element.html(text[action]);
        element.val(text[action]);
        return element.attr('disabled', disable);
      };

      /**
       * Watch for disable state changes
       */
      return scope.$watch('disable', function(newVal, oldVal) {
        if (angular.equals(newVal, oldVal)) {
          return;
        }
        return change(newVal);
      });
    },
  }));
